<template>
	<div class="stage stage--systeemdenken" v-if="state === 'question'" :style="{ 'background-image': backgroundImage }">
		
		<div class="content-container">

			<div class="header__container">
				
				<div class="header" style="position: relative;">
					{{roundData.header}}
				</div>
				<div class="subHeader" style="position: relative">
					{{roundData.subheader}}
				</div>

				<div class="text" style="position: relative;">
					{{questionData.questiontext}}
				</div>
			</div>

			<div class="btn__explanation" @click="showExplanationPopup">
				<i class="fa fa-question"></i>
			</div>

			<div class="systeem-container shadow-box shadow-box-systeemdenken card card-system">

				<div class="reset-button" @click="clear">
					<i class="fa fa-repeat" style="line-height: 40px; color: #fff; font-size: 24px;"></i>
				</div>

				<div class="world-button">
					<img src="../../../assets/svg/systeemdenken/output-icon.svg" class="icon"/>
				</div>

				<div class="systeem">

					<div class="systeem-canvas">
						<div class="canvas-container"></div>
					</div>
					<div class="systeem-ui">

						<v-touch v-for="(item,index) in items" :key="index"
							@tap="(e) =>{onClickItem(e,index)}"
							@press="(e) =>{onPressItem(e,index)}"
						>
							<div
								class="systeem-item"
								:class="{
									'active' : from==index,
									'deleting' : deleting==true && from==index,
								}"
								:style="{
									left:usedPositions[index].x+'%',
									top:usedPositions[index].y+'%',
									'box-shadow': item.icon !== undefined && item.icon !== null ? '0 0 0px rgba(0,0,0,0.05)' : '0 0 5px #ccc',
								}"
							>
								<img
									v-if="item.icon !== undefined && item.icon !== null"
									:src="baseUrl + item.icon"
									class="systeem-item-icon-img"
									:class="{'active' : from==index, 'deleting' : deleting==true && from==index}"
								>
								<div
									class="item__content"
									:class="{'text-offset' : item.icon !== undefined && item.icon !== null}"
								>
									{{item.name}}
								</div>
								
								
							</div>
						</v-touch>
					</div>
				</div>
			</div>

			<div class="systeem-controls">
				
				<!--<div class="arrow-type-holder" @click="toggleIncrease">
					<div class="buttons">
						<div class="decrease" :class="{'active' : !increase}">{{decreaseCount}}X</div>
						<div class="increase" :class="{'active' : increase}">{{increaseCount}}X</div>
					</div>
				</div>-->

				<div style="text-align: center">
					<table>
						<tr>
							<td style="width: 30%; text-align: right;">
								<span style="color: #48ddff;font-weight:bold">{{decreaseCount}}</span>

							</td>
							<td style="width: 30px; text-align: center;">
								<span class="arrow-icon__container" @click="()=>{increase = false;}">
									<img src="../../../assets/svg/systeemdenken/arrow_blue.svg" class="icon" style="width: 14px; height:20px;"/>
								</span>
							</td>
							<td style="text-align: center">
								<label class="switch">
									<input type="checkbox" v-model="increase">
									<span class="slider round"></span>
								</label>
							</td>
							<td style="width: 30px; text-align: center;">
								<span class="arrow-icon__container" @click="()=>{increase = true;}">
									<img src="../../../assets/svg/systeemdenken/arrow_red.svg" class="icon" style="width: 14px; height:20px;"/>
								</span>
							</td>
							<td style="width: 30%; text-align: left;">
								<span style="color: #ee4357;font-weight:bold">{{increaseCount}}</span>
							</td>
						</tr>
					</table>
					<div style="display: inline-block; width: auto;">
						
					</div>
				</div>
			</div>

			<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:additionalHTML="additionalHTML"
			:on-click="hideExplanationPopup"/>

		</div>

	</div>
	<div class="stage stage--systeemdenken-feedback" v-else-if="state === 'feedback'">
		<div class="header__container flex flexColumn">
			<div class="header order-1" style="position: relative; text-align: center">
				{{roundData.header}}
			</div>

			<div class="text order-2" style="position: relative; margin-top: 30px">
				{{feedbackText}}
			</div>
		</div>
	</div>
</template>

<script>
import Score from "../../Score.vue";
import { url } from "../../../const/base";
import { mapGetters, mapActions } from "vuex";
import ExplanationPopup from '../ExplanationPopup.vue';

export default {
	components: {
		Score,
		ExplanationPopup
	},

	data() {
		return {
			baseUrl: url,
			explanationPopupActive: false,
			usedPositions: [],
			positions: [
				[{ x: 50, y: 10 }, { x: 50, y: 95 }],
				[{ x: 50, y: 5 }, { x: 15, y: 70 }, { x: 85, y: 70 }],
				[
					{ x: 50, y: 10 },
					{ x: 90, y: 50 },
					{ x: 50, y: 90 },
					{ x: 10, y: 50 }
				],
				[
					{ x: 50, y: 10 },
					{ x: 230, y: 100 },
					{ x: 185, y: 210 },
					{ x: 55, y: 210 },
					{ x: 10, y: 100 }
				],
				[
					{ x: 70, y: 10 },
					{ x: 90, y: 50 },
					{ x: 70, y: 90 },
					{ x: 30, y: 90 },
					{ x: 10, y: 50 },
					{ x: 30, y: 10 }
				]
			],
			answers: [],
			answersArray: [],
			arrows: [],
			from: -1,
			deleting: false,
			increase: false,
			increaseCount: 0,
			decreaseCount: 0,
			score: 0,
			state: "question", //controle , question , feedback
			feedbackText: "",
			additionalHTML:"",
		};
	},

	beforeMount() {
		this.clear();
		this.buildInfoAddonHTML();

		//this.setTransitorSound('/media/gem_utrecht/transitors/punten.mp4');
	},

	mounted() {
		this.showTransitorScore(true);
	},

	computed: {
		...mapGetters([
			"lastQuestion",
			"currentBlock",
			"currentStage",
			"currentRound",
			"currentQuestion",
			"roundCount",
			"stageData",
			"roundCompleted",
			"scores",
			"questionData",
			"stageCount",
			"roundScore",
			"roundData"
		]),

		items() {
			return this.questionData.items;
		},

		backgroundImage: function() {
	        return 'url('+ this.baseUrl + this.roundData.question_background + ')';
	    },
	},

	watch: {
		currentQuestion: function(val) {
			this.clear();
		}
	},

	methods: {
		...mapActions([
			"setTransitorSound",
			"showTransitorScore",
			"increaseTransitorScore",
			"completeRound",
			"toNextQuestion",
			"addRoundScore",
			"logAnswers",
			"setRoundScore",
			"hideNextButton",
			"showNextButton",
			"setNextButtonAction"
		]),

		hideExplanationPopup(){
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},

		showExplanationPopup(){
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},


		buildInfoAddonHTML(){

			this.additionalHTML = '<div class="info">'+this.questionData.info+'</div>';

			this.additionalHTML += '<div class="item_info">';



			for (let i = 0; i < this.questionData.items.length; i++) {
				
				this.additionalHTML += '<div class="item">';
				this.additionalHTML += '<div class="item-header">'+this.questionData.items[i].name+'</div>';
				this.additionalHTML += '<div class="item-text">'+this.questionData.items[i].info+'</div>';
				this.additionalHTML += '</div>';

			}
			this.additionalHTML += '</div>';

		},

		toggleIncrease() {
			this.increase = !this.increase;
		},

		onClickItem(event, index) {
			if (this.deleting) {
				this.removeArrow(this.from, index);
				this.deleting = false;
				this.from = -1;
			} else {
				if (this.from == -1) {
					this.from = index;
				} else if (this.from == index) {
					this.from = -1;
				} else {
					let tempFrom = this.from;
					this.from = -1;

					if (this.drawArrow(tempFrom, index, this.increase)) {
						if (this.increase) this.increaseCount--;
						else this.decreaseCount--;
						this.answers.push({
							from: tempFrom,
							to: index,
							type: this.increase ? "increase" : "decrease"
						});

						if (
							this.increaseCount == 0 &&
							this.decreaseCount == 0
						) {
							this.setNextButtonAction(() => {
								this.showFeedback();
							}).then(() => {
								this.showNextButton();
							});
							// this.setNextButtonAction(()=>{this.completeQuestion();}).then(()=>{
							// 	this.showNextButton();
							// });
						}
					}
				}
			}
		},

		showFeedback() {
			this.answersArray.push(this.answers);
			let correctAnswers = this.questionData.answers;
			let correct = 0;

			console.log("correct answers before loop:");
			console.log(correct);

			for (let i = 0; i < this.answers.length; i++) {
				let answer = this.answers[i];

				for (let j = 0; j < correctAnswers.length; j++) {
					let correctAnswer = correctAnswers[j];

					let from = answer.from == +correctAnswer.from-1;
					let to = answer.to == +correctAnswer.to-1;
					let type =
						(answer.type == "decrease" &&
							correctAnswer.increase == "False") ||
						(answer.type == "increase" &&
							correctAnswer.increase == "True");

					if (from && to && type) {
						correct++;
					}
				}
			}

			console.log("correct answers:");
			console.log(correct);

			if (correct == correctAnswers.length) {
				console.log("is example");
				console.log(this.questionData.example);

				if (this.questionData.example !== "True") {
					this.score++;
					this.increaseTransitorScore(
						+this.roundData.transitor_multiplier
					);
				}

				this.feedbackText = this.questionData.question_feedback.correct;
			} else {
				this.feedbackText = this.questionData.question_feedback.incorrect;
			}

			this.state = "feedback";

			setTimeout(() => {
				this.setNextButtonAction(() => {
					this.completeQuestion();
				}).then(() => {
					this.showNextButton();
					console.log("showing nextBTN");
				});
			}, 500);

			console.log("showing feedback");

			this.answers = [];
		},

		completeQuestion() {
			this.state = "question";
			if (this.lastQuestion) {
				this.setRoundScore(
					this.score / this.roundData.questions.length * 100
				).then(() => {

					console.log('storing system skills answers');
					console.log(this.answersArray);

					this.logAnswers(this.answersArray).then(() => {
						this.completeRound();
					});
				});
			} else this.toNextQuestion();
		},

		clear() {
			this.increaseCount = 0;
			this.decreaseCount = 0;
			for (let answer of this.questionData.answers) {
				if (answer.increase === "True") {
					this.increaseCount++;
				} else {
					this.decreaseCount++;
				}
			}

			if(this.decreaseCount > this.increaseCount){
				this.increase = false;
			}else{
				this.increase = true;
			}

			this.from = -1;
			this.deleting = false;
			this.usedPositions = this.positions[this.items.length - 2];
			this.removeArrows();
			this.hideNextButton();
		},

		onPressItem(event, index) {
			if (this.from == index && this.deleting == true) {
				this.from = -1;
				this.deleting = false;
			} else {
				this.from = index;
				this.deleting = true;
			}
		},

		removeArrow(from, to) {
			let canvas = $("#" + "canvas_" + from + "_" + to);

			if (canvas.length) {
				let type = canvas.attr("datatype");
				for (let i = 0; i < this.answers.length; i++) {
					let answer = this.answers[i];
					if (
						answer.from === from &&
						answer.to === to &&
						type === answer.type
					) {
						if (type === "increase") this.increaseCount++;
						if (type === "decrease") this.decreaseCount++;
						this.answers.splice(i, 1);
						i--;
					}
				}
				canvas.remove();
				this.hideNextButton();
			}
		},

		removeArrows() {
			for (let arrow of this.arrows) {
				if (arrow != null) {
					arrow.remove();
				}
			}
			this.arrows = [];
		},

		drawArrow(from, to, increase) {
			if (increase && this.increaseCount == 0) return false;
			else if (!increase && this.decreaseCount == 0) return false;

			this.removeArrow(from, to);

			let id = "canvas_" + from + "_" + to;
			let w = parseInt($(".canvas-container").width());
			let h = parseInt($(".canvas-container").height());

			let arrowColor = increase ? "#ee4357" : "#48ddff";
			$("<canvas>")
				.attr({
					id: id,
					width: w,
					height: h,
					class: "arrow-canvas",
					datatype: increase ? "increase" : "decrease"
				})
				.appendTo(".canvas-container");

			console.log(id);

			let canvas = $("#" + id);
			this.arrows.push(canvas);
			let context = canvas[0].getContext("2d");

			const items = $(".systeem-ui").find(".systeem-item");

			let startPos = this.usedPositions[from];
			let endPos = this.usedPositions[to];

			items.each(function(i) {
				if (i === from) startPos = $(this).position();
				if (i === to) endPos = $(this).position();
			});

			this.drawArrowContext(
				context,
				startPos.left,
				startPos.top,
				endPos.left,
				endPos.top,
				arrowColor
			);
			return true;
		},

		drawArrowContext(ctx, fromx, fromy, tox, toy, color) {
			let headlen = 5;
			let angle = Math.atan2(toy - fromy, tox - fromx);
			//starting path of the arrow from the start square to the end square and drawing the stroke

			let distance = Math.hypot(tox - fromx, toy - fromy);
			let degrees = this.calculateAngle(fromx, fromy, tox, toy);

			let fromPos = this.translateCoords(
				tox,
				toy,
				degrees - 180,
				distance - 35
			);
			let toPos = this.translateCoords(
				fromx,
				fromy,
				degrees,
				distance - 40
			);

			fromPos = this.translateCoords(
				fromPos.x,
				fromPos.y,
				degrees + 90,
				6
			);
			toPos = this.translateCoords(toPos.x, toPos.y, degrees + 90, 6);

			let arrowPointLeft = {
				x: toPos.x - headlen * 2 * Math.cos(angle - Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle - Math.PI / 7)
			};

			let arrowPointRight = {
				x: toPos.x - headlen * 2 * Math.cos(angle + Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle + Math.PI / 7)
			};

			let tip = {
				x: toPos.x,
				y: toPos.y
			};

			ctx.beginPath();
			ctx.moveTo(fromPos.x, fromPos.y);
			ctx.lineTo(toPos.x, toPos.y);
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();

			//starting a new path from the head of the arrow to one of the sides of the point
			ctx.beginPath();
			ctx.moveTo(toPos.x, toPos.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);
			ctx.lineTo(arrowPointRight.x, arrowPointRight.y);
			ctx.lineTo(tip.x, tip.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);

			//draws the paths created above
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();
			ctx.fillStyle = color;
			ctx.fill();
		},

		calculateAngle(cx, cy, ex, ey) {
			let dy = ey - cy;
			let dx = ex - cx;
			let theta = Math.atan2(dy, dx); // range (-PI, PI]
			theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
			if (theta < 0) theta = 360 + theta; // range [0, 360)
			return theta;
		},

		translateCoords(xCoord, yCoord, angle, length) {
			length = typeof length !== "undefined" ? length : 10;
			angle = angle * Math.PI / 180; // if you're using degrees instead of radians
			return {
				x: length * Math.cos(angle) + xCoord,
				y: length * Math.sin(angle) + yCoord
			};
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/minigames/systeemdenken/Index.vue